import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import ERikshawBanner from "../../../Assets/Product_Images/ERikshawGlass/ERikshawGlass2.jpg";
// import E_Rickshaw1 from "../../../Assets/Product_Images/ERikshawGlass/ERikshawGlass1.jpeg";
// import E_Rickshaw2 from "../../../Assets/Product_Images/ERikshawGlass/ERikshawGlass2.jpeg";
import E_Rickshaw3 from "../../../Assets/Product_Images/ERikshawGlass/ERikshawGlass3.webp";
import E_Rickshaw4 from "../../../Assets/Product_Images/ERikshawGlass/ERikshawGlass4.jpeg";
import E_Rickshaw5 from "../../../Assets/Product_Images/ERikshawGlass/ERikshawGlass5.webp";
import { Link } from "react-router-dom";

const Automobile_tempered_glass = () => {
  return (
    <div>
      <Header />

      {/* banner section start  */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${ERikshawBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h2>
                  <Link
                    to="/AboutUs"
                    className="text-decoration-none text-white"
                  >
                    ABOUT US
                  </Link>{" "}
                  / <span className="text-white">E Rickshaw Glass</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner section end */}

      {/* about tabbing section start  */}
      <section className="container-fluid about_Products_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="blog_text wow fadeInUp">
                <h5 style={{ color: "#153fa4", fontFamily: "Segoe UI, sans-serif", fontSize: "40px", fontWeight: "700", marginBottom: "15px" }}>E Rickshaw Glass</h5>
                <p>
                  As a prominent manufacturer based in Mehsana, we specialize in
                  delivering high-quality spare parts for electric rickshaws.
                  Our products are designed to enhance safety, durability, and
                  performance, supporting the rapidly growing e-mobility market
                  across India.
                </p>
                <p>
                  <strong>E Rickshaw Wind Shield:</strong> Our E Rickshaw Wind
                  Shield is built using premium materials to provide superior
                  protection against dust, wind, and debris. Designed for
                  perfect fitment and visibility, this wind shield ensures a
                  comfortable and safe ride for both drivers and passengers.
                </p>
                <p>
                  Manufactured in India with a production capacity that scales
                  to meet high-volume demands, our wind shields are ideal for
                  OEMs, fleet owners, and distributors. With a transparent,
                  durable structure and smooth finish, this product is trusted
                  for its reliability in daily e-rickshaw operations.
                </p>
              </div>
              <div className="Products_img gap-5 mt-5 wow fadeInUp">
                {/* <img src={E_Rickshaw1} className="E_Rickshaw1" style={{width : "180px" , height : "180px"}} alt="E_Rickshaw1" />
                <img src={E_Rickshaw2} className="E_Rickshaw2" style={{width : "180px" , height : "180px"}} alt="E_Rickshaw2" /> */}
              <img src={E_Rickshaw5} className="E_Rickshaw5" style={{width : "250px" , height : "250px"}} alt="staff-bus" />
                <img src={E_Rickshaw3} className="E_Rickshaw3" style={{width : "250px" , height : "250px"}} alt="staff-bus" />
                <img src={E_Rickshaw4} className="E_Rickshaw4" style={{width : "250px" , height : "250px"}} alt="staff-bus" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about tabbing section End  */}

      <Footer />
    </div>
  );
};

export default Automobile_tempered_glass;
